import { Ref, ref } from "@vue/composition-api";
import { PolicyL0StatusItem } from "./model";
import * as api from "./api";
import { UseLoading } from "@/common/composition/loading";
import { InfoTypeHelper } from "@/common/models";

// https://dev.azure.com/shieldox/X2O/_workitems/edit/13983
// link : https://app.clickup.com/3752527/v/dc/3jgjf-43702/3jgjf-76662

const [is_loading, set_loading] = UseLoading(false).as_arr();

const status_list: Ref<PolicyL0StatusItem[]> = ref([]);

/* 

 Dropdown options
 ----------------
On Any High Severity Event   ==> tier1count({x:employees,y:severity:3,z:last_week}){uniqs}
On Any External Exposure High Severity Events
On Any Personal Address Exposure High Severity Events

policy key: AutomaticJustification

 highSeverity
 external_highSeverity
 personalAddress_highSeverity


 view list => events that follow the rule set in the dropdown

 remove the Est.
*/

const load_status_list = async () => {
  set_loading(true);
  const res = await api.get_justification_policy_status_list();
  if (res.success) {
    status_list.value = res.value.filter(
      (d) => d.id !== InfoTypeHelper.REGULATED_ID()
    );
  }
  set_loading(false);
};

const toggle_item_activity_state = async (item_id: string) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    const res = await api.toggle_l0_policy_status({
      id: item.id,
      activate: !item.is_active,
      selected_policy: item.policy_id,
    });
    if (res.success) {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            is_active: !d.is_active,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const update_policy = async (item_id: string, selected_policy: string) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    if (item.is_active) {
      const res = await api.toggle_l0_policy_status({
        id: item.id,
        activate: item.is_active,
        selected_policy,
      });
      if (res.success) {
        status_list.value = status_list.value.map((d) => {
          if (d.id === item_id) {
            return {
              ...d,
              policy_id: selected_policy,
            };
          }
          return d;
        });
      }
    } else {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            policy_id: selected_policy,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const init = async () => {
  await load_status_list();
};

export const state = {
  init,
  is_loading,
  status_list,
  toggle_item_activity_state,
  update_policy,
};
